export const monthFormat = {
  '01': 'Enero',
  '02': 'Febrero',
  '03': 'Marzo',
  '04': 'Abril',
  '05': 'Mayo',
  '06': 'Junio',
  '07': 'Julio',
  '08': 'Agosto',
  '09': 'Septiembre',
  '10': 'Octubre',
  '11': 'Noviembre',
  '12': 'Diciembre'
};
export const monthFormatBrasil = {
  '01': 'Janeiro',
  '02': 'Fevereiro',
  '03': 'Março',
  '04': 'Abril',
  '05': 'Maio',
  '06': 'Junho',
  '07': 'Julho',
  '08': 'Agosto',
  '09': 'Setembro',
  '10': 'Octubro',
  '11': 'Novembro',
  '12': 'Dezembro'
};

export const daysOfWeeks = {
  '0': 'Domingo',
  '1': 'Lunes',
  '2': 'Martes',
  '3': 'Miércoles',
  '4': 'Jueves',
  '5': 'Viernes',
  '6': 'Sábado'
};

export const daysOfWeeksBrasil = {
  '0': 'Domingo',
  '1': 'Segunda-feira',
  '2': 'Terça-feira',
  '3': 'Quarta-feira',
  '4': 'Quinta-feira',
  '5': 'Sexta-feira',
  '6': 'Sábado'
};

export const dateFormatted = value => {
  return (
    value &&
    value
      .toString()
      .split('/')
      .reverse()
      .join('-')
  );
};

export const newValueFormatted = value => {
  return (
    value &&
    value
      .toString()
      .split('-')
      .reverse()
      .join('/')
  );
};

export const newPeriodFormatted = value => {
  const format = value && value.toString().split('/');
  const firstP = format[0]
    .split('-')
    .reverse()
    .join('-');
  const seconfP = format[1]
    .split('-')
    .reverse()
    .join('-');
  return `${firstP} / ${seconfP}`;
};

export const monthYearFormatted = value => {
  const format = value && value.toString().split('-');
  const month = format[1];
  const year = format[0];
  return `${month}/${year}`;
};

export const newDateFormatted = date => {
  return new Date(
    date &&
      date
        .toString()
        .split('/')
        .reverse()
        .join('/')
  );
};

export const dateFormattedPeriod = value => {
  const startPeriod = value && value.toString().split('/')[0];
  const endPeriod = value && value.toString().split('/')[1];
  const formatArray = [`${newValueFormatted(startPeriod)} -`, newValueFormatted(endPeriod)];
  let exitArray = [];
  if (formatArray && formatArray[0] && formatArray[1]) {
    exitArray = formatArray;
    return exitArray;
  }
  return exitArray;
};

export const monthDateFormatted = date => {
  return date
    .toString()
    .split('/')
    .splice(1, 2)
    .join('/');
};

export const getDaysBetweenDates = (f1, f2) => {
  const aDate1 = f1 && f1.split('/');
  const aDate2 = f2 && f2.split('/');
  const fDate1 = Date.UTC(aDate1[2], aDate1[1] - 1, aDate1[0]);
  const fDate2 = Date.UTC(aDate2[2], aDate2[1] - 1, aDate2[0]);
  const dif = fDate2 - fDate1;
  const days = Math.ceil(dif / (1000 * 60 * 60 * 24)) + 1;
  return days;
};

export const formatDatePicker = value => {
  const newDate = new Date(
    value
      .split('/')
      .reverse()
      .join('-')
  );
  newDate.setDate(newDate.getDate() + 1);
  return newDate;
};
